// extracted by css-extract-rspack-plugin
export default {"ButtonGroup":"tIYmL"};